module.exports = __webpack_public_path__ + "img/fmn.7864e85a.svg";